import React from 'react'
import {CFComponentProps} from 'module/CustomField/type/CFComponentType';
import {CFModel} from 'module/CustomField/type/CFType';
import {Switch} from '@mui/material'
import {useCFAttrTextAlignCSS} from 'module/CustomField/style/CFAlignmentStyle'

export function JaNeinToggleComponent<M extends CFModel>({modelValue, disabled, cfDef, setCb}: CFComponentProps<'J' | 'N'>) {
	const checked = modelValue === 'J';
	return (
		<div css={useCFAttrTextAlignCSS(cfDef)}>
			<Switch
				color={'primary'}
				checked={checked}
				disabled={disabled}
				onChange={() => !disabled && setCb(checked ? 'N' : 'J')}
			/>
		</div>
	);
}